import React from "react";
import PropTypes from "prop-types";
import { Text, TextInput, Flex, Box, useMantineTheme } from "@mantine/core";
import { useStylesGeneral } from "../utils/mantine/stampTabContent/useStylesGeneral";
import { useStylesButton } from "../utils/mantine/useStylesButton";
import { useStylesLanding } from "../utils/mantine/useStylesLanding";
import CustomButton from "./mantineCustomComponents/CustomButton";

const VerifyContentId = ({
  isValid,
  showValidationError,
  objectHash,
  handleHashChange,
  handleSubmit,
}) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  const { classes: GeneralClasses } = useStylesGeneral();
  const { classes: buttonClasses } = useStylesButton();
  const { classes: landingClasses } = useStylesLanding();

  return (
    <Box id="verify-method-user-found__screen" className={GeneralClasses.wrap}>
      <Box className={GeneralClasses.wrapContent}>
        <Flex
          direction="column"
          gap={theme.flex.gap.large}
          justify={theme.flex.justify.start}
          align={theme.flex.align.center}
          classNames={{
            root: GeneralClasses.wrapContentContainer,
          }}
        >
          <Box className={GeneralClasses.wrapContentContainerPadding}>
            <Text>Content ID:</Text>
            <TextInput
              id="object-hash"
              placeholder="Enter content ID"
              value={objectHash ?? ""}
              classNames={{
                input: `${GeneralClasses.input} ${
                  showValidationError ? GeneralClasses.inputInvalid : ""
                }`,
              }}
              onChange={handleHashChange}
            />

            <Flex
              align={theme.flex.align.center}
              className={`${landingClasses.pricingBlockButtons} ${landingClasses.supplementaryInformationBlockButtons}`}
            >
              <CustomButton
                text="Verify"
                icon="IconChevronRight"
                disabled={!isValid}
                onClick={() => handleSubmit()}
                componentClasses={`btn-verify ${buttonClasses.buttonBlack} ${landingClasses.pricingBlockButtonsButton} ${GeneralClasses.button}`}
              />
            </Flex>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};
VerifyContentId.propTypes = {
  objectHash: PropTypes.string.isRequired,
  handleHashChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  showValidationError: PropTypes.bool.isRequired,
};
export default VerifyContentId;
